import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../shared/common.service';
import { AuthServiceLocal } from '../../auth.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {
  isLoading:boolean =false;
  projectDetail:any;
  userData:any;
  serialNumber="";
  tab="";
  constructor(
    private authServices: AuthServiceLocal, 
    private router: Router,  
    private commonService: CommonService,
    private route: ActivatedRoute) { }

  ngOnInit() {

    this.route.queryParams.subscribe((param) => {
      if(param["token"]){
        this.commonService.setStorage(
          "token",
          param["token"]
        );
        this.validateTokenApi(); 
      }else{
        this.validateTokenApi();
      }
      if(param['serialNumber']){
        this.serialNumber = param['serialNumber']
      }
      if(param['tab']){
        this.tab = param['tab']
      }
      
    });
   
  }
  validateTokenApi(){

    this.isLoading = true;
    this.authServices.validateToken().subscribe(
      (res) => {
        if ((res["message"] = "Success")) {
          this.isLoading = true;
          if(res.data['isTokenValid'] == false){
            window.open('https://tuftsapi.plexome.com/api/sso/tufts/login','_self')
          }else {
            res.data.userId = res.data._id
            localStorage.setItem('userData',JSON.stringify(res.data))
            if(res['data']["accessToken"]) {
              this.commonService.setStorage(
                "token",
                res['data']["accessToken"]
              );
            }
            let principalColor = "#873B0C"
            let coordinatorColor = "#1ba1e2"
            let researchAdminColor = "#1ba1e2"
            let admincolor = "#880ED4"

    this.projectDetail = JSON.parse(localStorage.getItem("full_project")) || "noemail";
    document.documentElement.style.setProperty('--theme_primary', this.projectDetail['primaryThemeColor']);
    if( res['data'].tuftsRole.length > 1) {
      document.documentElement.style.setProperty('--theme_secondary',coordinatorColor);
    }
    if( res['data'].tuftsRole.length == 1 && (res['data'].tuftsRole[0] == "CTO" || res['data'].tuftsRole[0] == "Admin" ||res['data'].tuftsRole[0] == "CTMS Support")) {
      document.documentElement.style.setProperty('--theme_secondary',admincolor);
    }
    if( res['data'].tuftsRole.length == 1 && res['data'].tuftsRole[0] == "Principal Investigator") {
      document.documentElement.style.setProperty('--theme_secondary',principalColor);
    }
    if( res['data'].tuftsRole.length == 1 && res['data'].tuftsRole[0] == "Researcher") {
      document.documentElement.style.setProperty('--theme_secondary',coordinatorColor);
    }
    if( res['data'].tuftsRole.length == 1 && res['data'].tuftsRole[0] == "Research Admin") {
      document.documentElement.style.setProperty('--theme_secondary',researchAdminColor);
    }
    this.projectDetail = JSON.parse(localStorage.getItem("full_project")) || "noemail"; 
    
    if(this.serialNumber !== "") {
      this.router.navigate(["main/tuft-dashboard"],{ queryParams: { serialNumber: this.serialNumber,tab:this.tab}}); 
     return
    }
    if(this.projectDetail['loginNavigationLink']) {
      if(res['data'].tuftsRole.length > 1) {
        this.router.navigate([this.projectDetail['loginNavigationLink']]);
      } else {

        this.router.navigate(['main/tuft-dashboard']);
      }                  
    } else {
      this.router.navigate(['main/tuft-dashboard']);
    }

          }
          
        } else {
        }
      },
      (err) => {
        window.open('https://tuftsapi.plexome.com/api/sso/tufts/login','_self')
        this.isLoading = false;
      }
    );
  }
}
